<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg3333"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs3337"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath3359"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path3357" /></clipPath></defs><g
     id="g3339"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g3341"
       transform="translate(169.9106,125.6865)"><path
         d="M 0,0 H 172.179"
         style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path3343" /></g><g
       id="g3345"
       transform="translate(169.9106,88.2705)"><path
         d="M 0,0 H 172.179"
         style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path3347" /></g><g
       id="g3349"
       transform="translate(195.5312,372)"><path
         d="M 0,0 V -125.21"
         style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path3351" /></g><g
       id="g3353"><g
         id="g3355"
         clip-path="url(#clipPath3359)"><g
           id="g3361"
           transform="translate(504.5,204.2666)"><path
             d="M 0,0 H -497"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3363" /></g><g
           id="g3365"
           transform="translate(504.5,143.2197)"><path
             d="m 0,0 v 197.007 c 0,19.013 -15.414,34.427 -34.427,34.427 h -7.825"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3367" /></g><g
           id="g3369"
           transform="translate(49.7524,374.6533)"><path
             d="m 0,0 h -7.826 c -19.013,0 -34.426,-15.414 -34.426,-34.427 v -296.11 c 0,-19.014 15.413,-34.427 34.426,-34.427 h 428.147 c 19.013,0 34.427,15.413 34.427,34.427 v 64.037"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3371" /></g><g
           id="g3373"
           transform="translate(166.6118,374.6533)"><path
             d="M 0,0 H -56.511"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3375" /></g><g
           id="g3377"
           transform="translate(298.335,374.6533)"><path
             d="M 0,0 H -72.767"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3379" /></g><g
           id="g3381"
           transform="translate(397.689,374.6533)"><path
             d="M 0,0 H -60.745"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3383" /></g><g
           id="g3385"
           transform="translate(49.7524,296.415)"><path
             d="M 0,0 V -92.147"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3387" /></g><g
           id="g3389"
           transform="translate(49.7524,403.8828)"><path
             d="M 0,0 V -72.401"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3391" /></g><g
           id="g3393"
           transform="translate(110.1006,204.2676)"><path
             d="M 0,0 V 199.615"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3395" /></g><g
           id="g3397"
           transform="translate(225.5684,204.2676)"><path
             d="m 0,0 v 197.137 c 0,10.099 4.617,19.794 12.828,25.675 10.993,7.875 16.181,21.724 12.868,35.005 l -8.324,33.373 c -1.001,4.015 -4.607,6.832 -8.744,6.832 H 2.911 c -7.52,0 -13.617,-6.096 -13.617,-13.618 v -23.96 c 0,-2.102 -0.377,-4.189 -1.112,-6.159 l -0.454,-1.216 c -2.571,-6.885 -9.148,-11.45 -16.498,-11.45 h -2.973 c -7.742,0 -14.576,5.057 -16.84,12.46 -0.511,1.669 -0.771,3.404 -0.771,5.15 v 24.906 c 0,7.511 -5.969,13.824 -13.479,13.886 -7.563,0.063 -14.172,-5.064 -16,-12.39 l -6.937,-27.814 c -3.376,-13.534 2.074,-27.667 13.5,-35.459 8.492,-5.79 13.313,-15.631 13.313,-25.909 L -58.957,0"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3399" /></g><g
           id="g3401"
           transform="translate(462.2476,204.2676)"><path
             d="m 0,0 v 171.046 c 0,5.989 -4.855,10.845 -10.845,10.845 h -42.869 c -5.989,0 -10.845,-4.856 -10.845,-10.845 V 0"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3403" /></g><g
           id="g3405"
           transform="translate(298.335,431.2441)"><path
             d="M 0,0 V -138.16"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3407" /></g><g
           id="g3409"
           transform="translate(336.9438,293.084)"><path
             d="M 0,0 V 138.16"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3411" /></g><g
           id="g3413"
           transform="translate(287.9868,260.9141)"><path
             d="m 0,0 h 59.305 c 8.884,0 16.085,7.201 16.085,16.085 0,8.883 -7.201,16.085 -16.085,16.085 H 0 c -8.884,0 -16.085,-7.202 -16.085,-16.085 C -16.085,7.201 -8.884,0 0,0 Z"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3415" /></g><g
           id="g3417"
           transform="translate(350.6343,204.2676)"><path
             d="M 0,0 V 56.999"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3419" /></g><g
           id="g3421"
           transform="translate(284.6445,261.2666)"><path
             d="M 0,0 V -56.999"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3423" /></g><g
           id="g3425"
           transform="translate(344.5898,446.0225)"><path
             d="M 0,0 -7.646,-14.778 H -46.255 L -53.901,0 c -1.902,3.676 -2.339,7.936 -1.223,11.922 l 10.401,37.154 c 1.194,4.264 5.08,7.212 9.509,7.212 h 16.527 c 4.429,0 8.315,-2.948 9.509,-7.212 L 1.223,11.922 C 2.339,7.936 1.902,3.676 0,0 Z"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3427" /></g><g
           id="g3429"
           transform="translate(110.1006,403.8818)"><path
             d="m 0,0 c 0,4.439 -0.576,8.117 -1.714,12.407 l -21.374,80.57 c -1.928,7.269 -12.244,7.269 -14.172,0 L -58.634,12.407 C -59.772,8.117 -60.348,4.439 -60.348,0 Z"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3431" /></g><g
           id="g3433"
           transform="translate(61.3633,453.5957)"><path
             d="M 0,0 H 37.126"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3435" /></g><g
           id="g3437"
           transform="translate(456.5708,384.8496)"><path
             d="m 0,0 v 67.708 c 0,4.438 -1.926,8.657 -5.278,11.565 l -43.226,37.488 c -1.839,1.594 -4.701,0.289 -4.701,-2.146 V 0"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3439" /></g><g
           id="g3441"
           transform="translate(403.3657,464.5303)"><path
             d="M 0,0 53.205,-46.143"
             style="fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3443" /></g></g></g></g></svg>
</template>
